import i18n from '@/plugins/vue-i18n.js';

export default {
    methods: {
        async getActivixExpUrl() {
            const schoolName = i18n.getContentLanguage() == 'fr' ? 'activix' : 'activixen';
            const jwt = await this.$api.activixExp.sso();

            return `https://${schoolName}.thinkific.com/api/sso/v2/sso/jwt?jwt=${jwt}`;
        },

        async openActivixExp(inNewTab = true) {
            const url = await this.getActivixExpUrl();

            if (inNewTab) {
                window.open(url, '_blank');
            } else {
                window.location.replace(url);
            }
        },
    },
};
